import type { FaireProductEntity } from "../../entity_types/product";

export const p_n5qeeq5yee: FaireProductEntity = {
  token: "p_n5qeeq5yee",
  type: "product",
  name: "Zulu Bowl 13- 16\" (Assorted)",
  brandToken: "b_6jbk8zuc",
  brandName: "Amsha",
  imageUrl: "https://cdn.faire.com/fastly/88071345e2ab83448a92f9392fbcd630031e472442c0f42d362a22ce5b63d238.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6382d64ca6dc005b82e0707cde5706f4095ab409467f3593cc20c222dc292b3e.jpeg",
    "https://cdn.faire.com/fastly/f68ef50fea1d0760dd82d28d5f202b5a13bbb78ba08127ebbcd33ce8c2ddcb78.jpeg",
    "https://cdn.faire.com/fastly/e95c735b343abf55a863ce05f118e59f414ef9c6824df7bba123c56175325d99.jpeg",
    "https://cdn.faire.com/fastly/7f1a4deb1f1540645b956ef970b9471c3740e1d9b4bc8d34ef4bbd6446f72196.jpeg",
    "https://cdn.faire.com/fastly/aca045b19a43117507689dda712bd74a780c745a782ed8223d6394245fa01dc0.png"
  ],
  priceDollars: 40,
  description: "These traditional bowls are woven in South Africa out of ilala palm and wild grasses. They are naturally dyed using mud, leaves, ash, and plants. Each basket is one-of-a-kind and you will receive a surprise pattern. Some are wider, some are deeper. Sold separately.\n\n• Width: 13-16\"\n• Height: 4.5-6\"",
  tags: [],
  msrpDollars: 80,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:20.041Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
